export const name = 'siteSiteThemeService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-site-theme'
